import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { X } from 'lucide-react';
export function TriedSection() {
  const triedItems = ['magnesio, melatonina, tés', 'podcasts para dormir', '“higiene del sueño”', 'rezar para no despertarte'];
  return <section className="py-24 px-4 bg-[var(--bg-primary)]" data-id="element-192">
      <div className="max-w-3xl mx-auto" data-id="element-193">
        <SectionWrapper data-id="element-194">
          <h2 className="text-3xl md:text-4xl mb-12 text-[var(--text-primary)]" data-id="element-195">
            Lo que probablemente ya intentaste <br data-id="element-196" />
            <span className="text-[var(--text-muted)] text-2xl md:text-3xl font-sans font-normal" data-id="element-197">
              (y por qué no te funcionó)
            </span>
          </h2>

          <p className="text-lg text-[var(--text-secondary)] mb-8" data-id="element-198">
            Si estás aquí, es porque ya hiciste "lo correcto":
          </p>
        </SectionWrapper>

        <ul className="space-y-4 mb-12 pl-4 border-l-2 border-[var(--bg-card-hover)]" data-id="element-199">
          {triedItems.map((item, index) => <SectionWrapper key={index} delay={0.1 + index * 0.1} data-id="element-200">
              <li className="flex items-center text-lg text-[var(--text-muted)] line-through decoration-[var(--red-soft)] decoration-2" data-id="element-201">
                <X className="w-5 h-5 mr-3 text-[var(--red-soft)] shrink-0" data-id="element-202" />
                {item}
              </li>
            </SectionWrapper>)}
        </ul>

        <SectionWrapper delay={0.5} data-id="element-203">
          <div className="space-y-6" data-id="element-204">
            <p className="text-xl text-[var(--text-primary)]" data-id="element-205">¿Y aún así?</p>
            <p className="text-2xl font-serif italic text-[var(--text-primary)]" data-id="element-206">
              Ahí estás. A las 3:07AM. Con los ojos abiertos.
            </p>

            <div className="p-6 bg-[var(--bg-card)] rounded-xl border-l-4 border-[var(--accent-amber)]" data-id="element-207">
              <p className="text-lg text-[var(--text-secondary)] mb-4" data-id="element-208">
                ¿Por qué falla todo eso?
              </p>
              <p className="text-xl md:text-2xl text-[var(--text-primary)] font-medium" data-id="element-209">
                Porque casi todo está diseñado para quedarte dormida al inicio.
                <br data-id="element-210" />
                <br data-id="element-211" />
                Pero tu problema es mitad de la noche.
                <br data-id="element-212" />Y mitad de la noche necesita:
              </p>
              <p className="text-3xl md:text-4xl font-serif text-[var(--accent-amber)] mt-4" data-id="element-213">
                un protocolo de rescate.
              </p>
            </div>
          </div>
        </SectionWrapper>
      </div>
    </section>;
}